import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { HotToastService } from "@ngneat/hot-toast";
import { DashboardService } from "src/app/dashboard/dashboard.service";
import { DashboardStore } from "src/app/dashboard/dashboard.store";
import { ConversationsService } from "../../conversations.service";
import { SharedDataService } from "src/app/dashboard/shared-data.service";
import { MomentModule } from "ngx-moment";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { FormsModule } from "@angular/forms";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { CommonModule } from "@angular/common";
import { TableModule } from "primeng/table";
import { CheckboxModule } from "primeng/checkbox";
import { BooksReviewService } from "src/app/dashboard/main/accountant/books-review/books-review.service";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { ReceiptModalComponent } from "./receipt-modal/receipt-modal.component";
import { FileUploadModalComponent } from "src/app/dashboard/main/accountant/modals/file-upload-modal.component";
import Pusher from "pusher-js";
import { environment } from "src/environments/environment";
import { QuickbooksIntegrationService } from "src/app/dashboard/quickbooks-integration.service";
import { FilePreviewDirective } from "src/app/dashboard/main/common/file-preview.directive";

@Component({
  selector: "app-qbo-client-task-item",
  templateUrl: "./qbo-client-task-item.component.html",
  styleUrls: ["./qbo-client-task-item.component.scss"],
  imports: [
    CommonModule,
    TooltipModule,
    FormsModule,
    TypeaheadModule,
    MomentModule,
    TableModule,
    CheckboxModule,
    ReceiptModalComponent,
    FilePreviewDirective,
  ],
})
export class QboClientTaskItemComponent implements OnInit {
  private _batchSelectedItems = [];
  get batchSelectedItems(): any {
    return this._batchSelectedItems;
  }
  set batchSelectedItems(val: any) {
    console.log("val", val);
    this._batchSelectedItems = val;
    this.onSelectItem();
  }

  @Input() qboTrackedItems = [];
  @Input() accounts = [];
  @Input() vendors = [];
  @Input() classes: any = { enabled: false, classes: [] };
  @Input() salesTaxes: any = [];
  @Input() hasSelectableClass = false;
  @Input() hasSelectableSalesTax = false;
  @Input() company: any = null;
  @Input() currentAccount: string = null;
  @Input() type: string = "";

  data: any = null;

  @Output() selectedTrackedItem: EventEmitter<any> = new EventEmitter();
  @Output() batchSelectItems: EventEmitter<any> = new EventEmitter();

  loading: boolean = false;

  inputValueHolder: string = "";

  modalRef?: BsModalRef;
  bsFileUploadModalRef?: BsModalRef;
  pusher: Pusher;

  removedReceipt = false;

  constructor(
    private conversationsService: ConversationsService,
    private dashboardStore: DashboardStore,
    private dashboardService: DashboardService,
    private toastr: HotToastService,
    private localStorageService: LocalStorageService,
    private sharedDataService: SharedDataService,
    private booksReviewService: BooksReviewService,
    private modalService: BsModalService,
    private quickbooksIntegrationService: QuickbooksIntegrationService,
  ) {}

  ngOnInit(): void {
    // console.log("salesTaxes", this.salesTaxes);
    // console.log("hasSelectableSalesTax", this.hasSelectableSalesTax);
    this.data = this.sharedDataService.data;

    this.qboTrackedItems.map(
      (t) =>
        (t.selectedVendorName =
          t.selectedVendorName == null
            ? t.integration_data.payee
            : t.selectedVendorName),
    );
    this.pusher = new Pusher(environment.pusherConfig.pusherAppKey, {
      cluster: environment.pusherConfig.pusherAppCluster,
    });
  }

  onSelectItem() {
    this.batchSelectItems.emit(
      this.batchSelectedItems.map((item) => item.uuid),
    );
  }

  async submitAnswer(tracked_item, isFromClose = false): Promise<void> {
    this.loading = true;
    this.dashboardService.show_loading.next(true);
    let fileForm = new FormData();

    if (tracked_item.selectedAccount != null) {
      fileForm.append(
        "qbo_account",
        JSON.stringify(tracked_item.selectedAccount),
      );
    }
    if (tracked_item.selectedClassId != null) {
      fileForm.append(
        "qbo_class",
        JSON.stringify(tracked_item.selectedClassId),
      );
    }
    if (tracked_item.selectedVendor != null) {
      fileForm.append(
        "qbo_vendor",
        JSON.stringify(tracked_item.selectedVendor),
      );
    }
    if (tracked_item.integration_data.deposit_comment != null) {
      fileForm.append(
        "qbo_deposit_comment",
        tracked_item.integration_data.deposit_comment,
      );
    }

    if (tracked_item.integration_data.memo) {
      let memoText = tracked_item.integration_data.memo.toString();
      if (memoText.length > 4000) {
        memoText = memoText.substring(0, 4000);
      }
      fileForm.append("qbo_memo", memoText);
    }

    if (tracked_item.selectedSaleTaxId != null) {
      fileForm.append(
        "qbo_sales_tax",
        JSON.stringify({
          id: tracked_item.selectedSaleTaxId,
          name: tracked_item.selectedSaleTax,
        }),
      );
    }

    fileForm.append("tracked_item_id", tracked_item.id);

    if (
      tracked_item.integration_data.receipt &&
      tracked_item.integration_data.receipt instanceof File
    ) {
      fileForm.append("receipt", tracked_item.integration_data.receipt);
    }

    if (this.removedReceipt) {
      fileForm.append("removed_receipt", "True");
      this.removedReceipt = false;
    }

    console.log({ tracked_item });

    try {
      await this.conversationsService.submit_answer(
        tracked_item.conversation,
        fileForm,
      );
      if (!isFromClose) {
        this.loading = false;
        // this.selectTrackedItem(tracked_item);
        this.dashboardService.show_loading.next(false);
        this.quickbooksIntegrationService.qboTrackedItemsCounts.update(
          (prevState) => ({
            unanswered_count: Math.max(prevState.unanswered_count - 1, 0),
            to_review_count: prevState.to_review_count + 1,
          }),
        );
      }
    } catch (err) {
      console.log(err);
      this.loading = false;
      this.dashboardService.show_loading.next(false);
    }
  }

  selectClass(event: any, tracked_item: any) {
    tracked_item.selectedClass = event.item.name;
    tracked_item.selectedClassId = event.item;
  }

  selectSalesTax(event: any, tracked_item: any) {
    tracked_item.selectedSaleTax = event.item.name;
    tracked_item.selectedSaleTaxId = event.item.id;
  }

  selectAccount(event: any, tracked_item: any) {
    tracked_item.selectedAccount = event.item;
    tracked_item.selectedAcc = event.item.name;

    console.log(event, tracked_item);
  }

  selectVendor(event: any, tracked_item: any) {
    tracked_item.selectedVendor = event.item;
    tracked_item.selectedVendorName = event.item.name;
  }

  selectTrackedItem(tracked_item) {
    this.selectedTrackedItem.emit(tracked_item);

    if (tracked_item != null) {
      for (let i = 0; i < this.qboTrackedItems.length; i++) {
        if (this.qboTrackedItems[i].id == tracked_item.id) {
          this.qboTrackedItems[i].selected = true;
          let t = this.qboTrackedItems[i];
          t.selectedVendorName =
            t.selectedVendorName == null
              ? t.integration_data.payee
              : t.selectedVendorName;
        } else {
          this.qboTrackedItems[i].selected = false;
        }
      }

      tracked_item.selected = true;
    }
  }

  async answerTrackedItem(trackedItem: any, satisfied: boolean): Promise<void> {
    this.loading = true;
    this.dashboardService.show_loading.next(true);

    if (satisfied) {
      try {
        await this.submitAnswer(trackedItem, true);
      } catch {
        this.loading = false;
        this.dashboardService.show_loading.next(false);
        return;
      }
    }

    try {
      const res: any = await this.conversationsService.answer_tracked_item(
        trackedItem.id,
        satisfied,
      );
      trackedItem = res.tracked_item;

      if (res.has_qbo_error) {
        this.toastr.error(res.message, {
          duration: 7000,
          dismissible: true,
        });
      } else {
        this.toastr.success("Updated successfully");
      }
    } catch ({ error }) {
      console.log("error", error);
    } finally {
      this.loading = false;
      this.dashboardService.show_loading.next(false);
      this.quickbooksIntegrationService.qboTrackedItemsCounts.update(
        (prev) => ({
          unanswered_count: satisfied
            ? prev.unanswered_count
            : prev.unanswered_count + 1,
          to_review_count: Math.max(prev.to_review_count - 1, 0),
        }),
      );
    }
  }

  goToQuickBooks(tracked_item): void {
    const id =
      tracked_item?.integration_data?.purchase_id != null
        ? tracked_item?.integration_data?.purchase_id
        : tracked_item?.integration_data?.deposit_id;

    window.open(
      `https://app.qbo.intuit.com/app/${
        tracked_item?.integration_data?.purchase_id != null
          ? "expense"
          : "deposit"
      }?txnId=${id}
    `,
      "_blank",
    );
  }

  focus(event: FocusEvent) {
    this.inputValueHolder = (event.target as HTMLInputElement).value;
    (event.target as HTMLInputElement).value = "";
  }

  blur(event: FocusEvent) {
    let field = (event.target as HTMLInputElement).value;
    if (field === "") {
      (event.target as HTMLInputElement).value = this.inputValueHolder;
    }
    this.inputValueHolder = "";
  }

  navigateToQBO(transaction_id, transaction_type) {
    this.booksReviewService.goToQuickBooks(transaction_id, transaction_type);
  }

  removeReceipt(tracked_item) {
    // debugger;
    if (tracked_item.integration_data.receipt?.etag) {
      this.removedReceipt = true;
    }
    tracked_item.integration_data.receipt = null;
    console.log("qboTrackedItems", this.qboTrackedItems);
  }

  openReceiptModal(tracked_item: any) {
    this.modalRef = this.modalService.show(ReceiptModalComponent, {
      initialState: { item: tracked_item },
      class: "modal-lg",
    });

    const comp = this.modalRef.content as ReceiptModalComponent;
    comp.fileUploaded.subscribe((file: File) => {
      if (!file) return;
      tracked_item.integration_data.receipt = file;
    });
  }
}
